'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function useCurrentLocation() {
  var shouldUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var updateInterval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var [state, setState] = React__namespace.useState({
    location: null,
    isLoading: false,
    error: null
  });
  var [iteration, forceUpdate] = React__namespace.useReducer(x => x + 1, 0);
  var intervalRef = React__namespace.useRef();
  React__namespace.useEffect(() => {
    var _navigator;

    var isActive = true;
    setState(_rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, state), {}, {
      isLoading: true
    }));

    if ((_navigator = navigator) !== null && _navigator !== void 0 && _navigator.geolocation) {

      _rollupPluginBabelHelpers.asyncToGenerator(function* () {
        var geoPromise = new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        });

        try {
          var {
            coords
          } = yield geoPromise;

          if (isActive) {
            setState({
              location: coords,
              error: null,
              isLoading: false
            });

            if (shouldUpdate) {
              intervalRef.current = setTimeout(forceUpdate, updateInterval);
            }
          }
        } catch (e) {
          if (isActive) {
            setState(_rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, state), {}, {
              error: e,
              isLoading: false
            }));
          }
        }
      })();
    }

    return () => {
      isActive = false;
      clearInterval(intervalRef.current);
    };
  }, [iteration, shouldUpdate, updateInterval]);
  return state;
}

exports.useCurrentLocation = useCurrentLocation;
